import { ref } from "vue";

export type OnboardingHeroKey = 0 | 1 | 2 | "submitted";

const onboardingHeroKey = ref<OnboardingHeroKey>(0);

export function useOnboardingHero() {
  function setOnboardingHero(key: OnboardingHeroKey) {
    onboardingHeroKey.value = key;
  }

  function resetOnboardingHero() {
    onboardingHeroKey.value = 0;
  }

  return { onboardingHeroKey, setOnboardingHero, resetOnboardingHero };
}
